import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface CardProps {
  isHighlighted: boolean
}

export const Card = styled.div<CardProps>`
  width: 100%;
  padding: ${Spacing.S24} ${Spacing.S16};
  border: ${({ isHighlighted }) => (isHighlighted ? `2px solid ${Color.Grey900}` : `1px solid ${Color.Grey200}`)};
  border-radius: ${BorderRadius.R16};
  text-align: left;
`
